import { Box, styled } from '@mui/material';

export const PlanningKpisSection = styled(Box)(() => ({
  width: '432px',
  height: '245px',
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  overflow: 'hidden',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
}));

export const PlanningKpisHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '14px 16px',
  backgroundColor: '#71B790',
  color: '#FFFFFF',
}));

export const PlanningKpisTitle = styled('span')(() => ({
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#FFFFFF',
}));

export const PlanningKpisGraphContainer = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  paddingBottom: '55px',
  backgroundColor: '#FFFFFF',
}));
